/**
 * 清除美团地图在 localStorage 中的缓存
 */

const mtdpmapCleaner = {
    cleanUp: () => {
        Object.keys(localStorage)
            .filter(key => key.indexOf('mtdpmap_') !== -1)
            // eslint-disable-next-line waimaie/no-direct-access-localstorage
            .forEach(key => localStorage.removeItem(key));
    },
    hasMTDPMap: () => {
        return Object.keys(localStorage).some(k => k.indexOf('mtdpmap_') !== -1);
    },
};

export default mtdpmapCleaner;
